import singleChoice from '@/views/questionnaire/customerManage/questionnaireList/components/singleChoice.vue';
import tableControl from '@/views/questionnaire/customerManage/questionnaireList/components/tableControl.vue';
import multipleChoice from '@/views/questionnaire/customerManage/questionnaireList/components/multipleChoice.vue';
import dateControl from '@/views/questionnaire/customerManage/questionnaireList/components/dateControl.vue';
import dropDownSelect from '@/views/questionnaire/customerManage/questionnaireList/components/dropDownSelect.vue';
import signModel from '@/views/questionnaire/customerManage/questionnaireList/components/signModel.vue'; //签名组件
import paragraphModel from '@/views/questionnaire/customerManage/questionnaireList/components/paragraphModel.vue'; //段落
import enclosureModel from '@/views/questionnaire/customerManage/questionnaireList/components/enclosureModel.vue'; //附件
import singleLineMultilineModel from '@/views/questionnaire/customerManage/questionnaireList/components/singleLineMultilineModel.vue'; //单行文本and多行文本
import paymentEstimateModel from '@/views/questionnaire/customerManage/questionnaireList/components/paymentEstimateModel.vue'; //赔付金额and估损金额
export default {
  props: {
    controlItem: {
      type: Object,
      default: () => {}
    },
    associationInfo: {
      type: Object,
      default: () => {}
    },
    formData: {
      type: Object,
      default: () => {}
    },
    echoNodeIsEdit: {
      type: Boolean,
      default: true //false不可以编辑true可编辑
    }
  },
  components: {
    singleChoice,
    tableControl,
    multipleChoice,
    dateControl,
    dropDownSelect,
    signModel,
    paragraphModel,
    enclosureModel,
    singleLineMultilineModel,
    paymentEstimateModel
  },
  methods: {
    changeControlShow(value, key) {
      this.$emit('changeControlShow', value, key);
    },
    validateTable() {
      this.$refs[`table${this.controlItem.mark}`].validateForm();
    },
    generationData() {
      this.$refs[`table${this.controlItem.mark}`].generationData2();
    }
  }
};